import styled from 'styled-components';

export const BasesContainer = styled.div`
  display: flex;
  height: 50px;
  justify-content: center;
  position: relative;
  width: 50px;
`;

export const Base = styled.div`
  background-color: #fff;
  height: 16px;
  position: absolute;
  transform: rotate(45deg);
  width: 16px;
`;

export const BaseLeft = styled(Base)`
  left: 0;
  top: 50%;
  transform: translateY(-50%) rotate(45deg);
`;

export const BaseRight = styled(Base)`
  right: 0;
  top: 50%;
  transform: translateY(-50%) rotate(45deg);
`;

export const BaseTop = styled(Base)`
  left: 50%;
  top: 0;
  transform: translateX(-50%) rotate(45deg);
`;

export const BasesOutsContainer = styled.div`
  align-items: center;
  background-color: #666;
  color: #fff;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  padding: 0 8px;
`;
BasesOutsContainer.displayName = 'BasesOutsContainer';

export const ColorsContainer = styled.div`
  border-radius: 4px;
  display: flex;
  height: 3px;
  margin-bottom: 4px;
  width: 100%;
`;
ColorsContainer.displayName = 'ColorsContainer';

export const Color = styled.div`
  flex-grow: 1;
`;
Color.displayName = 'Color';

export const Container = styled.section`
  border-radius: 4px;
  display: flex;
  font-family: 'Oswald', sans-serif;
  font-size: 35px;
`;
Container.displayName = 'Container';

export const Count = styled.div`
  align-items: center;
  background-color: #444;
  color: #fff;
  display: flex;
  font-size: 26px;
  justify-content: center;
`;
Count.displayName = 'Count';

export const Inning = styled.div`
  align-items: center;
  background-color: #333;
  color: #fff;
  display: flex;
  flex-direction: column;
  font-size: 26px;
  height: 100%;
  justify-content: center;
  line-height: 24px;
  padding: 0 8px;
`;
Inning.displayName = 'Inning';

export const NumbersContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 120px;
`;
NumbersContainer.displayName = 'NumbersContainer';

export const NumbersTopContainer = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
`;
NumbersTopContainer.displayName = 'NumbersTopContainer';

export const Outs = styled.div`
  display: flex;
`;
Outs.displayName = 'Outs';

export const Out = styled.div`
  background-color: #fff;
  border-radius: 50%;
  height: 8px;
  margin: 0 4px;
  width: 8px;
`;

export const Points = styled.div`
  background-color: #ccc;
  color: #000;
  font-weight: bold;
  height: 100%;
  min-width: 45px;
  text-align: center;
`;
Points.displayName = 'Points';

export const TeamContainer = styled.div`
  align-items: center;
  display: flex;
  min-height: 60px;
`;
TeamContainer.displayName = 'TeamContainer';

export const TeamName = styled.div`
  background-color: #eee;
  color: #000;
  height: 100%;
  min-width: 130px;
  padding: 0 32px;
  text-align: center;
  width: 100%;
`;
TeamName.displayName = 'TeamName';

export const TeamsContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 120px;
  width: 100%;
`;
TeamContainer.displayName = 'TeamContainer';
